function createPagination({
	namespace,
	initialState,
	stateNodeName = 'pagination'
}) {
	// action types
	const UPDATE = `${namespace}/${stateNodeName}/update`;

	// actions
	const actions =  {
		update: ({ page, total }) => ({
			type: UPDATE,
			payload: { page, total }
		})
	};

	// reducers
	const reducers = {
		[UPDATE]: (state, action) => ({
			...state,
			[stateNodeName]: {
				...state[stateNodeName],
				currentPage: action.payload.page,
				total: action.payload.total
			}
		})
	};

	// selectors
	const selectors = {
		getPagination: state => {
			return state[namespace][stateNodeName];
		}
	};

	return {
		initialState: {
			currentPage: 1,
			total: 0,
			perPage: initialState.perPage
		},
		actions,
		reducers,
		selectors
	};
}

export default createPagination;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/new-pagination/index.js